// extracted by mini-css-extract-plugin
export default {"overview":"Overview_overview__UquR2","title":"Overview_title__sk8Xw","icon":"Overview_icon__2BuLj"};